import { useAuthStore } from "@app/store";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PagesRoutes } from "../pages.routes";

interface PublicOnlyRouteProps {
  children: ReactNode;
}

/**
 * Route guard for public-only routes (e.g., login page)
 * Redirects to home if user is already authenticated
 */
export function PublicOnlyRoute({ children }: PublicOnlyRouteProps) {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to={PagesRoutes.home.index} replace />;
  }

  return <>{children}</>;
}
